import 'core-js/es/map';
import 'core-js/es/set';
import 'core-js/es/weak-map';
import 'core-js/es/array/from';
import 'core-js/es/object/assign';
//# sourceMappingURL=polyfills.js.map


//////////////////
// WEBPACK FOOTER
// /data/websites/bestcompany1982.it/httpdocs/wp-content/themes/g2k-theme-2/node_modules/smooth-scrollbar/polyfills.js
// module id = 121
// module chunks = 0